export default "__VITE_ASSET__BH1D0qj9__"